var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M173.704 101.227L173.694 101.247L173.686 101.267C173.253 102.276 167.373 113.828 155.308 125.116C143.258 136.392 125.073 147.375 100 147.375C74.9286 147.375 56.7441 136.315 44.693 125C32.6343 113.678 26.7441 102.124 26.2958 101.227C25.7764 100.188 25.7764 99.1867 26.2958 98.1479C26.7441 97.2514 32.6343 85.6969 44.693 74.3749C56.7441 63.06 74.9286 52 100 52C125.071 52 143.256 63.06 155.307 74.3749C167.366 85.6969 173.256 97.2514 173.704 98.1479C174.224 99.1867 174.224 100.188 173.704 101.227ZM33.4128 99.6252L33.1966 100L33.4128 100.375C38.1267 108.546 59.8828 140.75 100 140.75C140.117 140.75 161.873 108.546 166.587 100.375L166.803 100L166.587 99.6252C161.873 91.4545 140.117 59.25 100 59.25C59.8828 59.25 38.1267 91.4545 33.4128 99.6252Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9999 138.625C78.543 138.625 61.3749 121.152 61.3749 100C61.3749 78.8517 78.8516 61.375 99.9999 61.375C121.148 61.375 138.625 78.8517 138.625 100C138.625 121.152 121.457 138.625 99.9999 138.625ZM99.9999 68C82.3982 68 67.9999 82.3983 67.9999 100C67.9999 117.602 82.3982 132 99.9999 132C117.602 132 132 117.602 132 100C132 82.3983 117.602 68 99.9999 68Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 121.125C88.5322 121.125 78.875 111.766 78.875 100C78.875 98.2267 80.4142 96.6875 82.1875 96.6875C83.9608 96.6875 85.5 98.2267 85.5 100C85.5 107.914 91.7733 114.187 99.6875 114.187C107.602 114.187 113.875 107.914 113.875 100C113.875 92.0858 107.602 85.8125 99.6875 85.8125C97.9142 85.8125 96.375 84.2733 96.375 82.5C96.375 80.7267 97.9142 79.1875 99.6875 79.1875C111.155 79.1875 120.812 88.5462 120.812 100.313C120.812 112.079 111.468 121.125 100 121.125Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/ViewIcon.73478be34a4818576631f65431cfd60d.svg";
export { ForwardRef as ReactComponent };